// extracted by mini-css-extract-plugin
export default {"power-pivot-not-supported-modal":"PowerPivotNotSupportedModal_power-pivot-not-supported-modal__o9BXU"};